define(
    'C3.ShoppingExtensions.NewArrivals.Model',
    [
        'SCModel',
        'Utils'
    ],
    function(SCModelComponent, Utils){
        'use strict';

        var SCModel = SCModelComponent.SCModel;

        function NewArrivalsSCModel() {
            SCModel.call(this);

            // Define properties of the model.
            this.urlRoot = function() {
                Utils.getAbsoluteUrl(
                    getExtensionAssetsPath(
                        "services/NewArrivals.Service.ss"
                    )
                )
            }
        }

        NewArrivalsSCModel.prototype = Object.create(SCModel.prototype);

        NewArrivalsSCModel.prototype.constructor = NewArrivalsSCModel;

        // Return the AMD constructor.
        return NewArrivalsSCModel;
    }
);
